import React from "react";
import { makeStyles, InputAdornment, IconButton, TextField, CircularProgress } from "@material-ui/core";
import { LIGHT_GRAY_COLOR, SHADOW_GRAY_COLOR } from "../../theme";
import TextFieldIconSeparator from "./TextFieldIconSeparator";
import { criarCampoComMascara, MASCARA_NUMERO_ETIQUETA } from "../utils/Mascara";
import IconeCodigoBarras from "./IconeCodigoBarras";
import { X } from "react-feather";

const TextFieldBarCode = (props) => {
    const {
        label,
        value,
        onChange,
        className,
        loading,
        inputRef,
        handleIconButton,
        autoFocusEnable,
        possuiMascara
    } = props;

    const classes = useStyles();

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleIconButton();
        }
    }

    return (
        <TextField
            autoFocus={!autoFocusEnable ? false : autoFocusEnable}
            label={label}
            value={value}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            className={"largura-maxima " + className}
            variant='outlined'
            disabled={loading}
            inputRef={inputRef}
            InputProps={{
                inputComponent: (possuiMascara? MascaraCodigoAmostra : undefined),
                endAdornment: (
                    <InputAdornment position='end'>
                        {loading
                            ? <CircularProgress className={"mr-4"} size={16} />
                            : <>
                                {value.length
                                    ? <IconButton
                                        className={classes.iconButton}
                                        aria-label='Clear'
                                        onClick={() => onChange({ target: { value: "" } })}
                                    >
                                        <X size={16} />
                                    </IconButton>
                                    : null
                                }
                                <TextFieldIconSeparator />
                                <IconButton
                                    className={classes.iconButton}
                                    aria-label='Search'
                                    onClick={() => handleIconButton()}
                                >
                                    <IconeCodigoBarras />
                                </IconButton>
                            </>
                        }
                    </InputAdornment>
                ),
                classes: {
                    notchedOutline: classes.notchedOutline,
                    adornedEnd: classes.adornedEnd
                }
            }}
        />
    );
};

const MascaraCodigoAmostra = criarCampoComMascara("mascaraNumeroEtiqueta", MASCARA_NUMERO_ETIQUETA)

const useStyles = makeStyles((theme) => ({
    notchedOutline: {
        borderColor: LIGHT_GRAY_COLOR
    },
    adornedEnd: {
        paddingRight: "2px"
    },
    iconButton: {
        color: SHADOW_GRAY_COLOR,
    }
}))

export default TextFieldBarCode;